import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Alert } from "@material-ui/lab";
import { Helmet } from "react-helmet-async";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import ExchangeUserPairsEditForm from "./ExchangeUserPairsEditForm";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import Notification from "../../../elements/notification/Notification";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledFeeDetailsWrapper } from "../../../fee/styledFee";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../../styles/styledTabsForm";

const ExchangeUserPairsDetailsContainer = ({ match }) => {
  const { t } = useTranslation("exchangerPage");

  const [userPair, setUserPair] = useState();

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/user-exchange-pairs/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setUserPair(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!userPair) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (userPair.length === 0) {
    return <Alert severity="warning">{t("userPairs.details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>
            {t("userPairs.details.meta.title")} {userPair.exchangePair.inService.name} {userPair.exchangePair.inCurrency.asset} - {userPair.exchangePair.outService.name} {userPair.exchangePair.outCurrency.asset} • eXsoft.io
          </title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("userPairs.details.changeForm.give")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("userPairs.details.changeForm.inService")}
                  type="text"
                  value={getServiceNameWithNickname(userPair.exchangePair.inService.name, userPair.exchangePair.inService.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("userPairs.details.changeForm.inCurrency")}
                  type="text"
                  value={userPair.exchangePair.inCurrency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("userPairs.details.changeForm.receive")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("userPairs.details.changeForm.outService")}
                  type="text"
                  value={getServiceNameWithNickname(userPair.exchangePair.outService.name, userPair.exchangePair.outService.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("userPairs.details.changeForm.outCurrency")}
                  type="text"
                  value={userPair.exchangePair.outCurrency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("userPairs.details.changeForm.fee")}
              </StyledBlockLabel>
              <ExchangeUserPairsEditForm
                t={t}
                userPair={userPair}
                notification={notification}
                setNotification={setNotification}
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
}

export default ExchangeUserPairsDetailsContainer;